import { SportDataGatewayQueryInfo, SportDataGateway } from "sb-resp-lib";
import { observable } from "mobx";
import { EventPushResponse, Observer } from "sbtech-sports-data-api-client";
import { IPersonalizationMethodResponse } from "../../Interfaces";

export const initialSportsDataFeed: EventPushResponse = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    },
    warnings: []
};

export const failureSportsDataFeed: EventPushResponse = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    },
    warnings: []
};

/*
    The class has 'istanbul ignore' flag , because of testing typescript interface with Jest.
    It`s known issue : (https://github.com/kulshekhar/ts-jest/issues/378)
    The class is fully tested, but propery "sportsDataChangeFeed" implement interface "ChangeFeedUpdate" which is not
    testable with Jest - there is no types like in typescript
 */

/* istanbul ignore next */
export class SportDataGateWayRetriever {
    localeCodeQueryFormat: string;
    gateway: SportDataGateway;
    subscription: Observer | undefined;
    @observable sportsDataChangeFeed: EventPushResponse | undefined;
    @observable shouldRemoveEvents: boolean;

    constructor(localeCodeId: string = "en", gateway:SportDataGateway) {

        this.localeCodeQueryFormat = localeCodeId;
        this.sportsDataChangeFeed = initialSportsDataFeed;
        this.shouldRemoveEvents = false;
        this.gateway = gateway;
        this.subscription = undefined;

        this.messageHandler = this.messageHandler.bind(this);
    }

    activate(personalizationData: IPersonalizationMethodResponse) : void
    {
        let eventsQuery = this.queryBuilder(personalizationData);
        let queryInfo = new SportDataGatewayQueryInfo(eventsQuery, this.messageHandler);
        queryInfo.initialData = "true";
        queryInfo.locale = this.localeCodeQueryFormat;
        this.subscription && this.subscription.unsubscribe();
        this.subscription = this.gateway.subscribeForEvents(queryInfo);
    }

    setFailureSportsDataChangeFeed(eventIds: number[]): void {
        this.shouldRemoveEvents = true;
    }

    deactivate(): void {
        this.subscription && this.subscription.unsubscribe();
    }

    messageHandler(data: EventPushResponse): void {
        this.shouldRemoveEvents = false;
        // Observed by Data Facade for changes
        this.sportsDataChangeFeed = data;
    }

    queryBuilder(personalizationMethodResponse: IPersonalizationMethodResponse): string {
        /* istanbul ignore next */
        let sportDataApIQuery = "$filter=isLive eq false and id in (";

        personalizationMethodResponse.BranchGroups.forEach(function (branch) {
            branch.Events.forEach(function (event) {
                if (branch.Id !== 0) {
                    sportDataApIQuery += `'${event.Id}',`;
                }
            });
        });

        sportDataApIQuery = sportDataApIQuery.slice(0, -1) + ")";

        return sportDataApIQuery;
    }
}
